import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SvgIcon as UISvgIcon } from 'components/ui';

import styles from './checkbox.module.scss';

const Label = props => {
  const { name, text, ...rest } = props;

  return (
    <label htmlFor={name} {...rest}>
      {text}
    </label>
  );
};

Label.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

const Checkbox = props => {
  const {
    className,
    labelPosition,
    labelText,
    labelNo,
    labelYes,
    name,
    onBlur,
    onChange,
    onFocus,
    type,
    value
  } = props;

  return (
    <div
      className={classnames(styles.container, className, {
        [styles.labelAbove]: labelPosition === 'above',
        [styles.labelLeft]: labelPosition === 'left',
        [styles.labelRight]: labelPosition === 'right'
      })}
    >
      {labelPosition === 'top' ||
        (labelPosition === 'left' && (
          <Label name={name} text={labelText} className={styles.labelText} />
        ))}

      <input
        type="checkbox"
        name={name}
        id={name}
        className={styles.checkbox}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
      />

      <label
        htmlFor={name}
        className={classnames({
          [styles.switch]: type === 'switch',
          [styles.normal]: type === 'checkbox'
        })}
      >
        {type === 'checkbox' && <UISvgIcon name="check" />}
        {type === 'switch' ? (
          <>
            <span className={styles.labelYes}>{labelYes}</span>
            <span className={styles.labelNo}>{labelNo}</span>
          </>
        ) : null}
      </label>

      {labelPosition === 'bottom' ||
        (labelPosition === 'right' && (
          <Label name={name} text={labelText} className={styles.labelText} />
        ))}
    </div>
  );
};

Checkbox.defaultProps = {
  labelYes: 'yes',
  labelNo: 'no',
  labelPosition: 'right',
  type: 'switch'
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  className: PropTypes.string,
  labelNo: PropTypes.string,
  labelPosition: PropTypes.oneOf(['left', 'right', 'above']),
  labelYes: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.oneOf(['checkbox', 'switch']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Checkbox;
